<template>
    <div class="sign-up-wrap">
        <md-stepper ref="stepper" @completed="confirm">
            <md-step :md-editable="!hasCreateAccount">
                <VendorSignupAccount ref="VendorSignupAccount" />
            </md-step>
            <md-step :md-editable="!hasCreateMerchant">
                <VendorSignupTilled v-if="showTilled" :product_codes="product_codes" :terms_and_conditions_links="terms_and_conditions_links" ref="VendorSignupTilled" />
            </md-step>
            <md-step :md-editable="!hasCreatePayment">
                <div v-if="showTilledCard">
                    <p class="md-subheading" style="text-align: center;">Will be used to process app fees for cash and check transactions</p>
                    <VendorSignupTilledCard ref="VendorSignupTilledCard" />
                </div>
            </md-step>
            <md-step>
                <LocationVendorSetting v-if="showLocationSetting" :isNew="true" ref="LocationVendorSetting" />
            </md-step>
        </md-stepper>
    </div>
</template>

<script>
import VendorSignupAccount from "@/components/Vendor/VendorSignupAccount";
import VendorSignupTilled from "@/components/Vendor/Tilled/VendorSignupTilled";
import VendorSignupTilledCard from "@/components/Vendor/Tilled/VendorSignupTilledCard";
import LocationVendorSetting from "@/components/Location/LocationVendorSetting";
import { mapGetters } from "vuex";
export default {
    components: {
        VendorSignupAccount,
        VendorSignupTilled,
        VendorSignupTilledCard,
        LocationVendorSetting
    },
    data() {
        return {
            record: {},
            currentStep: 0,
            hasCreateAccount: false,
            hasCreateMerchant: false,
            hasCreatePayment: false,
            showTilled: false,
            showTilledCard: false,
            showLocationSetting: false,
            customValidate: [],
            product_codes: [],
            terms_and_conditions_links: []
        };
    },
    computed: {
        ...mapGetters({
            user: "user/user"
        })
    },
    methods: {
        async confirm() {
            let instance = this.$refs["LocationVendorSetting"];
            await instance.save();
            this.$store.commit("setMessage", "Signup success");
            this.$router.push("/");
        }
    },
    mounted() {
        this.customValidate.push(async activeStepNumber => {
            let instance = this.$refs["VendorSignupAccount"];
            let status = await instance.customValidate();
            if (status) {
                let data = await instance.save();
                this.showTilled = true;
                this.product_codes = data.application.product_codes;
                this.terms_and_conditions_links = data.application.terms_and_conditions_links;
                this.hasCreateAccount = true;
            } else {
                this.$store.commit("setMessage", "Please complete fields");
            }
            return status;
        });

        this.customValidate.push(async activeStepNumber => {
            let instance = this.$refs["VendorSignupTilled"];
            let status = await instance.customValidate();

            if (status) {
                let data = await instance.save();
                if (data.validation_errors.length) {
                    return false;
                }

                this.currentStep = activeStepNumber;
                this.showTilledCard = true;
                this.hasCreateMerchant = true;
            } else {
                this.$store.commit("setMessage", "Please complete fields");
            }

            return status;
        });

        this.customValidate.push(async activeStepNumber => {
            let status = false;
            const paymentMethodId = await this.$refs["VendorSignupTilledCard"].getPaymentMethodId();

            if (paymentMethodId) {
                await this.$store.dispatch("crud/post", {
                    api: "users/vendor/signup",
                    data: {
                        paymentMethodId
                    }
                });
                status = true;
                this.hasCreatePayment = true;
                this.showLocationSetting = true;
            } else {
                this.$store.commit("setMessage", "Please complete fields");
            }
            return status;
        });

        this.customValidate.push(async activeStepNumber => {
            return true;
        });

        const that = this;

        this.$nextTick(() => {
            let stepLock = false;
            this.$refs["stepper"].setActiveStep = async function(stepData) {
                if (stepLock) {
                    return;
                }

                const nextStepNumber = this.getStepIndex(stepData.id);

                if (this.activeStepNumber === nextStepNumber) {
                    return;
                }
                if (this.activeStepNumber > nextStepNumber && !stepData.editable) {
                    return;
                }
                stepLock = true;

                try {
                    let r = await that.customValidate[this.activeStepNumber](nextStepNumber);
                    if (!r) {
                        stepLock = false;
                        return;
                    }
                } catch (error) {
                    stepLock = false;
                    throw error;
                }

                stepLock = false;
                this.activeStep = stepData.id;
                this.activeStepNumber = nextStepNumber;
                this.calculatePosition();
                this.$emit("change", this.activeStepNumber);
            };
        });

        window.onbeforeunload = async function() {
            await window.localStorage.removeItem("authUser");
            window.onbeforeunload = null;
        };
    },
    async beforeDestroy() {
        window.localStorage.removeItem("authUser");
        window.onbeforeunload = null;
    }
};
</script>
<style lang="less" scoped>
.sign-up-wrap /deep/ .md-step-actions {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}

.sign-up-wrap /deep/ .md-step-content .md-button:nth-of-type(2) {
    display: none;
}
</style>
